import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";

const LoadingSpinner = () => {
    return (
        <Container>
            <div className="d-flex justify-content-center align-items-center min-vh-100">

                <Spinner />
            </div>

        </Container>
    )
}

export default LoadingSpinner
